<script>
import { convertCurrency } from '~/assets/js/methods';

import VueModal from '@kouts/vue-modal';
import '@kouts/vue-modal/dist/vue-modal.css';
import OrderbumpsVariations from './OrderbumpsVariations.vue';

export default {
    name: "OrderbumpsCaroussel",
    props: ["getOrderBumps", "orderbumpUncheck"],
    setup() {
        return {
            convertCurrency
        };
    },
    computed: {
        getCart() {
            return this.$store.getters["getCart"];
        }
    },
    components: { OrderbumpsVariations, 'Modal': VueModal },
    data() {
        return {
            showModal: false,
            carousel: {
                items: [],
                current: 0
            }
        }
    },
    beforeMount(){
        this.carousel.items = this.getOrderBumps
    },
    mounted() {
        // if(this.$store.getters['getStore'].account_id === 40){
        //     this.showModal = true;
        // }
    }
}
</script>

<template>
    <div>
        <div class="js-orderbumps" v-if="getOrderBumps.length > 0">
            <div class="holder_orderbumps">
                <div class="orderbumps_flex -center ">
                    <div class="orderbumps_offer-total flex hcenter shake">
                        <span class="emoji">🎉</span>
                        VOCÊ TEM {{ getOrderBumps.length }} OFERTA!
                    </div>
                    <div class="orderbumps_owl-navigation ">
                        <div :class="{'lockclick disabled': carousel.current === 0}" @click="carousel.current--" class="owl-navigation_button prev js-owl-navigation_button js-btn-orderbump-owl-nav-prev"  style="display: inline-flex; align-items: center; vertical-align: middle; justify-content: center;">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 15px;">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg>
                        </div>
                        <div :class="{'lockclick disabled': carousel.current === (carousel.items.length-1)}" @click="carousel.current++" class="owl-navigation_button next js-owl-navigation_button js-btn-orderbump-owl-nav-next" style="display: inline-flex; align-items: center; vertical-align: middle; justify-content: center;">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 15px;">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="orderbumps owl-orderbumps js-owl-orderbumps owl-carousel owl-loaded">
                    <div class="orderbumps owl-orderbumps js-owl-orderbumps owl-carousel owl-loaded orderbumps owl-orderbumps js-owl-orderbumps">
                        <div v-for="(item, index) in getOrderBumps" :key="`orderbumps_${index}`" style="margin-bottom:10px;" v-if="carousel.current === index">
                            <OrderbumpsVariations  :orderBumpData="item" :key="index" />
                        </div>
                    </div>

                    <div class="owl-nav disabled">
                        <div class="owl-prev">prev</div>
                        <div class="owl-next">next</div>
                    </div>
                    <div class="owl-dots">
                        <div  class="owl-dot" @click="carousel.current = index" v-for="(item,index) in carousel.items" :key="index" :class="{'active': index===carousel.current}"><span></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .lockclick{
        pointer-events:none
    }

    .unlockclick{
        pointer-events:all
    }
</style>
